exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "page[data-v-7cee8ff4]{width:100%;position:relative}.wap-home[data-v-7cee8ff4]{margin-top:-11%}.wap-home div[data-v-7cee8ff4]{width:90%;margin:0 auto}.wap-home img[data-v-7cee8ff4]{width:100%}.icp[data-v-7cee8ff4]{color:#777;position:absolute;bottom:20px;font-size:16upx;width:100%;text-align:center;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cee8ff4","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/wapHome.vue
// module id = 169
// module chunks = 0